function get (name) {
  const cookie = {}
  document.cookie.split(';').forEach((el) => {
    const [k, v] = el.split('=')
    cookie[k.trim()] = v
  })
  return cookie[name]
}

/**
 * Sets cookie
 * @returns {void}
 * @param {string} name - The name for the cookie
 * @param {string} value - The value in string to store in cookie
 * @param {Date} expiry - The expiry time for cookie in Date object
 */
function setCookie (name, value, expiry) {
  const expires = `; expires=${expiry.toUTCString()}`
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}

export default {
  get, setCookie, getCookie: get
}
